// extracted by mini-css-extract-plugin
export default {"container":"container-lZ1os","bold":"bold-pPwN3","agreement":"agreement-xzWji","actions":"actions-QvwW3"};